import React from 'react';
import styles from '../ResultModalLayout.module.css';

const UserBookLayout = ({
    show,
    onHide,
    title,
    children,
    loading = false
}) => {
    if (!show) return null;

    return (
        <div className={`modal show d-block ${styles.modalOverlay}`} tabIndex="-1" role="dialog">
            <div className={`modal-dialog modal-lg ${styles.modalDialogCustom}`} role="document" style={{ maxWidth: '80%', width: '80%' }}>
                <div className={`modal-content ${styles.casinoResultModal}`}>
                    <header className={`modal-header ${styles.modalHeader}`}>
                        <h5 className={`modal-title ${styles.modalTitle}`}>
                            {title}
                        </h5>
                        <button
                            type="button"
                            className={`close ${styles.closeButton}`}
                            onClick={onHide}
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </header>
                    <div className={`modal-body ${styles.modalBody}`}>
                        {loading ? (
                            <div className="text-center p-4">
                                <div className="spinner-border text-light" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            children
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserBookLayout;

